export default __webpack_public_path__ + "static/media/BannerImage.8cc06429.JPG";